// Generated by ts-to-zod
import { z } from 'zod';
import { idSchema, urlSchema } from '../../utils/codecUtils.schema';

export const ruleAutomationBlockerDetailsSchema = z.object({
  ruleId: z.number(),
  ruleName: z.string().optional(),
});

export const formulaAutomationBlockerDetailsSchema = z.object({
  sourceSchemaId: z.string(),
  hookName: z.literal('computed_fields').optional(),
  hookId: z.number().optional().nullable(),
});

export const extensionAutomationBlockerDetailsSchema = z.object({
  hookId: z.number(),
  hookName: z.string(),
});

export const automationBlockerDetailsSchema = z.union([
  ruleAutomationBlockerDetailsSchema,
  formulaAutomationBlockerDetailsSchema,
  extensionAutomationBlockerDetailsSchema,
  z.object({
    ruleId: z.number().optional(),
    ruleName: z.string().optional(),
    hookId: z.number().optional(),
    hookName: z.string().optional(),
    sourceId: z.number().optional(),
    sourceSchemaId: z.string().optional(),
  }),
]);

export const automationBlockerSampleSchema = z.object({
  datapointId: z.number(),
  details: z
    .object({
      content: z.array(z.string()).optional(),
      messageContent: z.array(z.string()).optional(),
      score: z.number().optional(),
      threshold: z.number().optional(),
      detail: z.array(automationBlockerDetailsSchema).optional(),
    })
    .optional(),
});

export const annotationAutomationBlockerSchema = z.object({
  level: z.literal('annotation'),
  type: z.union([
    z.literal('automation_disabled'),
    z.literal('is_duplicate'),
    z.literal('suggested_edit_present'),
    z.literal('error_message'),
    z.literal('human_confirmation_required'),
    z.literal('extension'),
    z.literal('delete_recommendation_filename'),
    z.literal('delete_recommendation_page_count'),
    z.literal('delete_recommendation_field'),
    z.literal('alternative_prediction'),
  ]),
  details: z
    .object({
      content: z.array(z.string()).optional(),
      messageContent: z.array(z.string()).optional(),
      detail: z.array(automationBlockerDetailsSchema.nullable()).optional(),
    })
    .optional(),
});

export const datapointAutomationBlockerSchema = z.object({
  level: z.literal('datapoint'),
  type: z.union([
    z.literal('low_score'),
    z.literal('failed_checks'),
    z.literal('no_validation_sources'),
    z.literal('error_message'),
    z.literal('extension'),
  ]),
  schemaId: z.string(),
  samples: z.array(automationBlockerSampleSchema),
  samplesTruncated: z.boolean(),
});

export const automationBlockerSchema = z.union([
  annotationAutomationBlockerSchema,
  datapointAutomationBlockerSchema,
]);

export const failedAutomationResultSchema = z.object({
  id: idSchema,
  url: urlSchema,
  annotation: urlSchema,
  content: z.array(automationBlockerSchema),
});
